import { RouteWithAuth as LegacyRouteWithAuth } from '@common/components/RouteWithAuth';
import type { RouteWithAuthProps } from '@common/components/RouteWithAuth';
import { RenterAuthBoundary } from './RenterAuthBoundary';
import { useRenterAuthEnabled } from './RenterAuthProvider';

export const RenterRouteWithAuth = (props: RouteWithAuthProps) => {
  if (!useRenterAuthEnabled()) return <LegacyRouteWithAuth {...props} />;
  return <RenterAuthBoundary {...props} />;
};
